// extracted by mini-css-extract-plugin
export default {"inputContainer":"Input_inputContainer__biQhj","label":"Input_label__HhlQ5","required":"Input_required__8fBII","input":"Input_input__PuFbt"};